import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=0aa378fe&scoped=true&"
import script from "./Invitation.vue?vue&type=script&lang=js&"
export * from "./Invitation.vue?vue&type=script&lang=js&"
import style0 from "../assets/styleLogin.css?vue&type=style&index=0&id=0aa378fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa378fe",
  null
  
)

export default component.exports